export default __webpack_public_path__ + "static/media/14-Our-Participation-in-Asia-Pharma-Expo-2019.7efc9187.jpeg";